import { component } from "picoapp";

export default component((node) => {
  const textList = [];
  let filteredList = [...textList];
  let currentIndex = 0;
  node.querySelectorAll(".animate-text-item").forEach((element) => {
    textList.push(element.innerText);
  });

  const stopButton = document.createElement("button");
  stopButton.innerText = "Stop Animation";
  stopButton.ariaLabel = "Stop Animation";
  stopButton.classList.add("sr-only");
  node.parentElement.parentElement.appendChild(stopButton);
  let timeoutErase;
  let timeoutAnimate = null;

  stopButton.addEventListener("click", () => {
    clearTimeout(timeoutAnimate);
    clearTimeout(timeoutErase);
  });

  let text = selectRandomText(textList);
  const actualText = node.querySelector(".animate-text");

  actualText.innerText = text;
  currentIndex = text.length;

  function selectRandomText(list) {
    return list[~~(Math.random() * list.length)];
  }

  function eraseText() {
    if (currentIndex < 0) {
      filteredList = filteredList.filter((word) => word !== text);
      if (!filteredList.length) {
        filteredList = [...textList];
      }
      text = selectRandomText(filteredList);

      currentIndex = 0;
      timeoutAnimate = setTimeout(animateText, 1000);
      return;
    }
    actualText.innerText = text.substr(0, currentIndex--);
    timeoutErase = setTimeout(eraseText, ~~(Math.random() * 40 + 35));
  }

  function animateText() {
    if (currentIndex > text.length) {
      timeoutErase = setTimeout(eraseText, 1200);
      return;
    }
    actualText.innerText = text.substr(0, currentIndex++);
    timeoutAnimate = setTimeout(animateText, ~~(Math.random() * 80 + 60));
  }

  document.addEventListener("DOMContentLoaded", function () {
    animateText();
  });
});
